import styled from 'styled-components'

export const ButtonResetBase = styled.div<{ hidden?: boolean }>`
  position: absolute;
  inset-block-start: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  visibility: ${props => (props.hidden ? 'hidden' : 'visible')};
  width: 24px;
  height: 24px;
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  inset-inline-end: 8px;
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;

  [dir='rtl'] & {
    right: unset;
    left: 8px;
  }

  /* Inner circle with main color */
  &::before {
    content: '';
    position: absolute;
    inset-block-start: 50%;
    inset-inline-start: 50%;
    transform: translate(calc(var(--transform-direction) * -50%), -50%);
    width: 16px;
    height: 16px;
    border-radius: 100%;
    background-color: var(--color--neutral--600);
    transition: background-color 100ms ease-in;
    z-index: var(--z-base);
  }

  /* Border area for hover */
  &::after {
    content: '';
    position: absolute;
    inset-block-start: 0;
    inset-inline-end: 0;
    inset-block-end: 0;
    inset-inline-start: 0;
    border-radius: 100%;
    background-color: transparent;
    transition: background-color 100ms ease-in;
  }

  &.button-reset svg {
    padding-block: 0;
    padding-inline: 0;
    fill: var(--color--base--white);
    width: 10px;
    height: 10px;
    position: relative;
    z-index: var(--z-base);
  }

  &:hover::after {
    background-color: var(--color--neutral--500);
  }
`
